import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import OrganizationUserHeader from './OrganizationUserHeader';
import OrganizationUserList from './OrganizationUserList';

const OrganizationUserDetail = () => {
    const { id: proId, userId } = useParams<{ id: string; userId: string }>();

    if (!proId || !userId) {
        return <Box>Company or User not found</Box>;
    }

    return (
        <Box sx={{ width: '100%' }}>
            <OrganizationUserHeader
                userId={userId}
                proId={proId}
            />
            <OrganizationUserList />
        </Box>
    );
};

export default OrganizationUserDetail;
